module.exports = __webpack_public_path__ + "img/s3.36b54686.png";